import React from 'react';
import './App.css';
import PuzzleSelector from "./components/puzzleSelector";

function App() {
  return (
    <div className="App">

      <PuzzleSelector />
    </div>
  );
}

export default App;
